import { PrismicContent } from './PrismicContent/PrismicContent';
import { PrismicContentContextProvider } from './PrismicContent/usePrismicContent';

export function MarketingContent() {
  return (
    <PrismicContentContextProvider>
      <PrismicContent />
    </PrismicContentContextProvider>
  );
}
